import React from "react";
import ServiceDetailsHero from "../components/ServiceDetailsHero";
import ServiceDetailsServices from "../components/ServiceDetailsServices";
import FeaturedInsights from "../components/FeaturedInsights";
import EngagementOptionsServiceDetails from "../components/EngagementOptionsServiceDetails";
import FaqPage from "../components/FrequentlyQuestions";

const ServiceDetailsPage = () => {
  return (
    <div>
      <ServiceDetailsHero />
      <ServiceDetailsServices />
      <EngagementOptionsServiceDetails />
      <FeaturedInsights />
      <FaqPage />
    </div>
  );
};

export default ServiceDetailsPage;
